var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-cascader',{attrs:{"options":_vm.options},model:{value:(_vm.selectedOptions3),callback:function ($$v) {_vm.selectedOptions3=$$v},expression:"selectedOptions3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }